import { render, staticRenderFns } from "./ProdottoAssicurativoForm.vue?vue&type=template&id=3f7049be&scoped=true"
import script from "./ProdottoAssicurativoForm.vue?vue&type=script&lang=js"
export * from "./ProdottoAssicurativoForm.vue?vue&type=script&lang=js"
import style0 from "./ProdottoAssicurativoForm.vue?vue&type=style&index=0&id=3f7049be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7049be",
  null
  
)

export default component.exports